export const getDataSources = () => "api/Datasources";

export const getDataSourceById = (dataSourceId: number) =>
  `api/Datasources/${dataSourceId}`;

export const getAdministrationDataSourceTableRow = (rowKey: number) =>
  `api/Datasources/GetTableRow/${rowKey}`;

export const getAdministrationDataSourceTable = (
  pageNum: number,
  maxPageRowCount: number,
  orderSearch: string,
  hiddenColumns: string[],
  fulltextKeyword: string | undefined
) => {
  let url = `api/DataSources/GetTable?pageNum=${pageNum}&maxPageRowCount=${maxPageRowCount}&orderSearch=${orderSearch}`;
  if (fulltextKeyword) url += `&fulltextKeyword=${fulltextKeyword}`;

  return url;
};

export const postDataSource = () => "api/DataSources";

export const updateDataSource = (rowKey: string | number) =>
  `api/DataSources/${rowKey}`;

export const deleteDataSource = (rowKey: string | number) =>
  `api/DataSources/${rowKey}`;

export const checkDataSourceState = (dataSourceId: number) =>
  `api/Datasources/CheckDatasourceState/${dataSourceId}`;

export const checkDataSourcesStates = () =>
  "api/Datasources/CheckDatasourceState";

export const getMappedDataSources = () => "api/UserAccount/CheckMappingBulk";

export const getMappedDataSourcesByUserId = (userId: number) =>
  `api/UserAccount/CheckMappingBulk/ByUserId/${userId}`;

export const postResetColumnSchema = () => "api/Datasources/ResetColumnSchema";

export const getTimeZoneOptionsUrl = () => `/api/Datasources/GetTimeZones`;

export const getHegClassesFolders = (datasourceId: number) =>
  `/api/Datasources/${datasourceId}/HegClassesFolders`;
